import React from "react";

export const PulseDot = ({ tone = "electric", label, testid }) => {
  const cls = tone === "critical" ? "pulse-dot critical" : tone === "gold" ? "pulse-dot gold" : "pulse-dot";
  return (
    <span className="inline-flex items-center gap-2" data-testid={testid}>
      <span className={cls} />
      {label && <span className="text-[11px] uppercase tracking-[0.22em] text-cream-dim">{label}</span>}
    </span>
  );
};

export default PulseDot;
